'use client'

import { motion } from 'motion/react'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import {
  benefitCards,
  PROCESS_STEPS,
  SIMPLE_PROCESS_TRANSLATION_KEYS
} from '../forClubsLandingContent.constants'
import {
  imageHoverVariants,
  imageRevealVariants,
  staggerContainer
} from './animations'
import S from './ForClubsSimpleProcess.module.scss'

const ForClubsSimpleProcess = () => {
  const t = useTranslations('forClubsPage')
  return (
    <section id="for-clubs-simple-process" className={S.simpleProcess}>
      <p className={S.sectionEyebrow}>
        {t.has('simpleProcess.eyebrow')
          ? t('simpleProcess.eyebrow')
          : 'Simple process'}
      </p>
      <h2 className={S.sectionTitle}>
        <span>
          {t.has('simpleProcess.headlineLine1')
            ? t('simpleProcess.headlineLine1')
            : 'How Arena Works'}
        </span>
        <span>
          {t.has('simpleProcess.headlineLine2')
            ? t('simpleProcess.headlineLine2')
            : 'For Your Club'}
        </span>
      </h2>
      <div className={S.benefitBlock}>
        <div className={S.container}>
          <motion.div
            className={S.cardsGrid}
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
          >
            {benefitCards.map((card, index) => {
              const isTextTop = card.textPosition === 'top'
              const translationEntry = SIMPLE_PROCESS_TRANSLATION_KEYS[index]
              const fallbackStep = PROCESS_STEPS[index]
              const title =
                translationEntry &&
                t.has(`simpleProcess.${translationEntry.titleKey}`)
                  ? t(`simpleProcess.${translationEntry.titleKey}`)
                  : fallbackStep?.title ?? ''
              const description =
                translationEntry &&
                t.has(`simpleProcess.${translationEntry.descriptionKey}`)
                  ? t(`simpleProcess.${translationEntry.descriptionKey}`)
                  : fallbackStep?.description ?? ''

              return (
                <div key={card.id} className={S.card}>
                  {isTextTop && (
                    <div className={S.cardContentTop}>
                      <div className={S.indicator} />
                      <h3 className={S.title}>{title}</h3>
                      <p className={S.description}>{description}</p>
                    </div>
                  )}

                  <motion.div
                    className={`${S.imageWrapper} ${
                      isTextTop
                        ? S.imageWrapperAnchorBottom
                        : S.imageWrapperAnchorTop
                    }`}
                    variants={imageRevealVariants(card.textPosition)}
                  >
                    <motion.div
                      variants={imageHoverVariants}
                      initial="rest"
                      whileHover="hover"
                      className={S.imageHoverLayer}
                    >
                      <div className={S.cardImage}>
                        <Image
                          src={
                            card.imageUrl ??
                            `/assets/forClubs/clubSteps-${card.id}.webp`
                          }
                          alt={title}
                          fill
                          className={S.imagePlaceholder}
                          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 324px"
                        />
                        <div className={S.imageOverlay} />
                      </div>
                    </motion.div>
                  </motion.div>

                  {!isTextTop && (
                    <div className={S.cardContentBottom}>
                      <div className={S.indicator} />
                      <h3 className={S.title}>{title}</h3>
                      <p className={S.description}>{description}</p>
                    </div>
                  )}
                </div>
              )
            })}
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default ForClubsSimpleProcess
